export default "__VITE_ASSET__01876656__"